import { createApp } from 'vue'
import App from './App.vue'

if (import.meta.env.MODE !== 'production') {
  // Testing Browse Filter
  window.search = window.search || {};
  // window.search.apiKey = 'key_d2v8AQzh2FO0CBCC'; // dev
  window.search.apiKey = 'key_h3FB52owC3VYSBVq'; // stage
  // window.search.apiKey = 'key_QJLvEWqfGxS5JkmY'; // prod
  window.search.heading = 'Top Items';
  window.search.config = {
    desktop: {
      search: 8,
      visual: 3,
      withRecent: 4
    },
    mobile: {
      search: 5,
      visual: 4,
      withRecent: 4
    }
  };

  window.cloudinaryPlaceholderUrl = "https://res.cloudinary.com/scrubsandbeyond/image/upload/search/placeholder.jpg";
}

const autocomplete = createApp(App);
autocomplete.config.idPrefix = 'ac';
autocomplete.config.globalProperties.idPrefix = autocomplete.config.idPrefix;
autocomplete.mount('#search-autocomplete')
